/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Location City (`grey-600`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_LOCATION_CITY_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 176 176" width="176" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.3989 39.3989 0 88 0C136.601 0 176 39.3989 176 88V144C176 161.673 161.673 176 144 176H88C39.3989 176 0 136.601 0 88Z"
      fill="#F5F5F5"
    />
    <path
      className="svg-path-primary"
      clipRule="evenodd"
      d="M103.001 54.6093V80.4593H123.001C128.501 80.4593 133.001 84.9593 133.001 90.4593V120.459C133.001 125.959 128.501 130.459 123.001 130.459H53.001C47.501 130.459 43.001 125.959 43.001 120.459V70.4593C43.001 64.9593 47.501 60.4593 53.001 60.4593H73.001V54.6093C73.001 51.9593 74.051 49.4093 75.951 47.5093L84.451 39.0093C85.3851 38.073 86.6534 37.5469 87.976 37.5469C89.2986 37.5469 90.5668 38.073 91.501 39.0093L100.051 47.5593C101.951 49.4093 103.001 51.9593 103.001 54.6093ZM53 120.46H63V110.46H53V120.46ZM63 100.462H53V90.4616H63V100.462ZM53 80.4636H63V70.4636H53V80.4636ZM93.0018 120.46H83.0018V110.46H93.0018V120.46ZM83.0018 100.462H93.0018V90.4616H83.0018V100.462ZM93.0018 80.4636H83.0018V70.4636H93.0018V80.4636ZM83.0018 60.456H93.0018V50.456H83.0018V60.456ZM122.999 120.46H112.999V110.46H122.999V120.46ZM112.999 100.462H122.999V90.4616H112.999V100.462Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <circle cx="132" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132 107.834C118.636 107.834 107.833 118.636 107.833 132.001C107.833 145.365 118.636 156.167 132 156.167C145.364 156.167 156.166 145.365 156.166 132.001C156.166 118.636 145.364 107.834 132 107.834Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="138" />
  </svg>
);
